import type { Breakpoints } from "$src/core/models/theme";
import pickClosestResponsiveBreakpoint from "$src/core/utils/styling/pick-closest-responsive-breakpoint";

/**
 * Pick a value from the breakpoints that is closest to the current breakpoint,
 * in a mobile-first / min-width approach, which mirrors Unistyles behavior.
 */
const pickFromBreakpoints = <T = number>(
  breakpoints: Partial<Breakpoints>,
  breakpoint?: keyof Breakpoints | "landscape" | "portrait",
): T | undefined => {
  let currentBreakpoint = breakpoint ?? "md";
  if (currentBreakpoint === "landscape" || currentBreakpoint === "portrait") {
    currentBreakpoint = "md";
  }

  const closestBreakpoint = pickClosestResponsiveBreakpoint(
    breakpoints,
    currentBreakpoint,
  );
  if (!closestBreakpoint) return undefined;
  return breakpoints[closestBreakpoint] as T | undefined;
};

export default pickFromBreakpoints;
